<template>
  <v-app id="top">
    <v-container>
      <v-col class="top-wrapper">
        <transition
          name="custom-classes-transition"
          enter-active-class="animated slideInUp"
          leave-active-class="animated bounceOut"
        >
          <v-row justify="center">
            <v-col cols="3" xs="3" sm="2" md="1" lg="1">
              <v-img src="@/assets/logo.svg" v-if="logoShow"></v-img>
            </v-col>
            <TitleLogo class="title-logo" v-if="logoShow" />
          </v-row>
        </transition>
        <v-row justify="center">
          <v-col cols="11" xs="11" sm="8" md="5" lg="5">
            <v-row class="form_row" justify="center">
              <transition
                name="custom-classes-transition"
                enter-active-class="animated fadeIn"
                leave-active-class="animated bounceOut"
              >
                <NormalTextField
                  label="ID"
                  :form-data.sync="email"
                  :form-show="formShow"
                />
              </transition>
            </v-row>
            <v-row class="form_row" justify="center">
              <transition
                name="custom-classes-transition"
                enter-active-class="animated fadeIn"
                leave-active-class="animated bounceOut"
              >
                <PassTextField
                  label="PASS"
                  :form-data.sync="pass"
                  :form-show="formShow"
                />
              </transition>
            </v-row>
            <v-row class="btn_row" justify="center">
              <transition
                name="custom-classes-transition"
                enter-active-class="animated fadeIn"
                leave-active-class="animated bounceOut"
              >
                <NormalButton
                  button-title="ログイン"
                  :form-show="formShow"
                  @clickAction="login"
                />
              </transition>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-container>
  </v-app>
</template>

<script>
import TitleLogo from "../Molecules/TitleLogo";
import NormalTextField from "../Atoms/NormalTextField";
import PassTextField from "../Atoms/PassTextField";
import NormalButton from "../Atoms/NormalButton";
import errorHandle from "../../util/errorHandle.js";

export default {
  name: "Login",
  data: () => ({
    logoShow: false,
    formShow: false,
    email: "",
    pass: ""
  }),
  mounted() {
    this.logoShow = !this.logoShow;
    setTimeout(() => {
      this.fadeIn();
    }, 1000);
  },
  methods: {
    login() {
      console.log("email", this.email);
      console.log("this.pass", this.pass);
      const data = { email: this.email, password: this.pass };
      this.$store
        .dispatch("user/login", data)
        .then(() => {
          const user_info = this.$store.getters["user/getUserInfo"];
          const teamId = user_info.teamIds[0];
          this.$store.commit("team/SET_TEAM_INFO", teamId);
          this.$router
            .push({
              name: "Top",
              params: {}
            })
            .catch(() => {});
        })
        .catch(error => {
          errorHandle
            .errorHandle(this, error)
            .then(() => {})
            .catch(function(error) {
              console.log("エラーハンドリング失敗。エラー内容：", error);
            });
          console.log(error);
        });
    },
    // 各フォームの内容が変わるたびにVueXにデータを保存する
    updateForm(inputEvent) {
      console.log("inputEvent", inputEvent);
    },
    fadeIn() {
      this.formShow = !this.formShow;
    }
  },
  components: {
    TitleLogo,
    NormalTextField,
    NormalButton,
    PassTextField
  },
  head: {
    title: {
      inner: "login"
    },
    link: [
      {
        rel: "stylesheet",
        href:
          "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.css",
        id: "animate.css",
        type: "text/css"
      }
    ]
  }
};
</script>

<style scoped>
#top {
  height: 100%;
  background: transparent linear-gradient(180deg, #3c638f 0%, #74b8be 100%) 0%
    0% no-repeat padding-box;
}
.top-wrapper {
  padding: 10% 0 10% 0;
}
.title-logo {
  margin-bottom: 50px;
}
.form_row {
  margin-top: 0;
  margin-bottom: 10px;
}
.btn_row {
  margin: 50px -12px 30px -12px;
}
.login-btn {
  border-radius: 12px;
}
.link_row p {
  color: #ffffff;
}
</style>
